module.exports = __webpack_public_path__ + "font_beautiful.6d3ef131.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/female_to_male/font_beautiful.png
// module id = Gpon
// module chunks = 0